<template>
  <div class="user-visit-sector">
    <div class="sector red" :class="{'active': sector==='RED', 'disabled': disableUpdate}" @click="chooseSector('RED')">
      RED
    </div>
    <div class="sector blue" :class="{'active': sector==='BLUE', 'disabled': disableUpdate}" @click="chooseSector('BLUE')">
      BLUE
    </div>
    <div class="sector green" :class="{'active': sector==='GREEN', 'disabled': disableUpdate}" @click="chooseSector('GREEN')">
      GREEN
    </div>
    <div class="sector yellow" :class="{'active': sector==='YELLOW', 'disabled': disableUpdate}" @click="chooseSector('YELLOW')">
      YELLOW
    </div>
  </div>
</template>

<script>
  import Switches from "vue-switches";

  export default {
    name: "UserVisitSector",
    components: {Switches},
    props: {
      sector: {
        type: String
      },
      disableUpdate: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      chooseSector(sector) {
        if (this.disableUpdate) {
          return false
        }
        if (sector === this.sector) {
          this.$emit("updateUserSector", null)
        } else {
          this.$emit("updateUserSector", sector)
        }

      }
    },

  };
</script>

<style lang="scss">
  @import "UserVisitSector";
</style>
